import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

        idlist:[]
		// menuList:JSON.parse(sessionStorage.getItem('menuList') || '[]')
  },
  mutations: {

       getidlist(state,n){

        state.idlist=n
       }


		// setMenuList(state,data){
		// 	state.menuList = data
		// 	sessionStorage.setItem('menuList', JSON.stringify(data)) 
		// }
  },
  actions: {
  },
  modules: {
  }
})
